import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import "animate.css";
import '../styles/NotFound.css';
import doodleAnimation from '../assets/Page Not Found 404.json';
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
    <Helmet>
        <title>404 - Page Not Found | Laxmi Hospitality Services</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="prerender-status-code" content="404" />
        <meta name="errorpage" content="true" />
        <meta name="errortype" content="404 - Not Found" />
        <link rel="canonical" href="https://laxmihospitalityservices.in/404" />
      </Helmet>

    <div className="not-found-hero-section">
      <img
        src="/images/About-us-banner.jpg"
        alt="Laxmi Hospitality Services background"
        className="not-found-hero-image"
      />
      <div className="not-found-hero-overlay">
        <div className="not-found-content-wrapper">
          
          <div className="lottie-hero-container animate__animated animate__zoomIn">
            <Lottie 
              animationData={doodleAnimation} 
              loop={true} 
            />
          </div>

          <p className="not-found-description animate__animated animate__fadeInUp">
            The page you requested could not be found. It might have been moved, renamed, or is temporarily unavailable. Let's get you back on track.
          </p>

          <Link to="/" className="not-found-home-button animate__animated animate__fadeInUp">
            <span>Return to Homepage</span>
            <svg 
              className="arrow-icon"
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path 
                fillRule="evenodd" 
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" 
                clipRule="evenodd" 
              />
            </svg>
          </Link>
          
        </div>
      </div>
    </div>
    </>
  );
};

export default NotFound;